import UserTableAccessor from "../../components/common/UserTableAccessor";

const lastUpdatedByColumn = (onIdSelect, Header = "Last Updated By") => ({
  id: "updatedBy",
  Header,
  accessor: UserTableAccessor("updatedBy", onIdSelect),
});

export default lastUpdatedByColumn;
